import { compose, withProps, withState, withHandlers, setPropTypes, defaultProps } from 'recompose';
import PropTypes from 'prop-types';
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
import { all_status } from "./consts";
var enhancer = compose(componentErrorBoundary, withProps(function (_ref) {
  var isInactive = _ref.isInactive,
    status = _ref.status;
  return {
    status: isInactive ? 'no_status' : status
  };
}), withState('open', 'setOpen', false), withHandlers({
  onChoose: function onChoose(_ref2) {
    var setOpen = _ref2.setOpen,
      onChange = _ref2.onChange,
      status = _ref2.status;
    return function (nextStatus) {
      setOpen(false);
      if (!onChange) return;
      if (status !== nextStatus) onChange(nextStatus);
    };
  },
  onOpen: function onOpen(_ref3) {
    var setOpen = _ref3.setOpen,
      open = _ref3.open;
    return function () {
      if (open) return;
      setOpen(true);
    };
  },
  onClose: function onClose(_ref4) {
    var setOpen = _ref4.setOpen,
      open = _ref4.open;
    return function () {
      if (!open) return;
      setOpen(false);
    };
  }
}), setPropTypes({
  status: PropTypes.oneOf(all_status).isRequired,
  noLabel: PropTypes.bool,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  readOnly: PropTypes.bool,
  onChoose: PropTypes.func,
  setOpen: PropTypes.func
}), defaultProps({
  noLabel: false
}));
export default enhancer;